var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SegmentControl',{staticClass:"mb-2",attrs:{"label":_vm.label,"name":"tournamentAvailabilityType","options":_vm.$options.variants},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }